import { DefinitionStat } from '@/components/common/definitionStat'
import { useSettingsContext } from '@/context/settings'
import type { Vault } from '@/types/vault'
import { getApyCopy } from '@/utils/apy'
import { cn } from '@/utils/cn'
import { formatPreciseTokenValue } from '@vaultsfyi/common/utils'

interface PositionSummaryProps {
  isReturnsLoading: boolean
  positionValue: bigint
  returnsNative: bigint | undefined
  vault: Vault
}

export const PositionSummary = ({ isReturnsLoading, positionValue, returnsNative, vault }: PositionSummaryProps) => {
  const { apyRange, includeRewards } = useSettingsContext()
  const { apy, apyComposite, asset } = vault

  const formattedPositionValue = formatPreciseTokenValue({
    value: positionValue,
    decimals: asset.decimals,
  })
  const formattedReturns =
    returnsNative === undefined
      ? '––'
      : `${returnsNative > 0n ? '+' : ''}${formatPreciseTokenValue({
          value: returnsNative,
          decimals: asset.decimals,
        })} ${asset.symbol}`

  return (
    <dl className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      <DefinitionStat
        label="Current APY"
        value={getApyCopy({ apy, apyRange, includeRewards, apyComposite })}
        className="gap-1 rounded-2xl border bg-page p-4"
        valueClassName="truncate"
      />
      <DefinitionStat
        label="Position size"
        value={`${formattedPositionValue} ${asset.symbol}`}
        className="gap-1 rounded-2xl border bg-page p-4"
        valueClassName="truncate"
      />
      <DefinitionStat
        label="Total returns"
        value={isReturnsLoading ? '––' : formattedReturns}
        className="gap-1 rounded-2xl border bg-page p-4"
        valueClassName={cn(
          'truncate',
          returnsNative !== undefined && returnsNative > 0n && 'text-success',
          returnsNative !== undefined && returnsNative < 0n && 'text-destructive'
        )}
        isLoading={isReturnsLoading}
      />
    </dl>
  )
}
